module.exports = __webpack_public_path__ + "static/media/personal-diary.2a5f9a82.png";